import { of } from 'rxjs';
import {
  qpiConnaissanceOptions,
  qpiEsgOptions,
  qpiProfilOptions,
  qpiTolerancePerteOptions,
  inOperator,
} from '../../filtre-investisseur-helper';
import { FiltreBuilder, ItemFiltreCustomBuilder } from '../filtre-builder.model';

export function getProfilInvestisseurBuilders(): FiltreBuilder[] {
  return [
    new ItemFiltreCustomBuilder(
      'PROFIL_INVESTISSEUR',
      'QPI_PROFIL_RISQUE_INV',
      'investisseurQpis.some.resultatProfilDeRisque',
      inOperator,
      'SelectMultiple',
      of(qpiProfilOptions)
    ),
    new ItemFiltreCustomBuilder(
      'PROFIL_INVESTISSEUR',
      'QPI_TOLERANCE_PERTE',
      'investisseurQpis.some.tolerancePerte',
      inOperator,
      'SelectMultiple',
      of(qpiTolerancePerteOptions)
    ),
    new ItemFiltreCustomBuilder(
      'PROFIL_INVESTISSEUR',
      'QPI_CONNAISSANCE',
      'investisseurQpis.some.resultatConnaissance',
      inOperator,
      'SelectMultiple',
      of(qpiConnaissanceOptions)
    ),
    new ItemFiltreCustomBuilder(
      'PROFIL_INVESTISSEUR',
      'QPI_ESG',
      'investisseurQpis.some.resultatSensibiliteExtraFinanciere',
      inOperator,
      'SelectMultiple',
      of(qpiEsgOptions)
    ),
  ];
}
